import './flipButton.css';

import Button from '../button/button';

export default function FlipButton({onClick}) {
    return(
        <div>
            <button className="button-flip" onClick={onClick}> 
                Flip
                <svg className="free-trial-button-arrow" width="46.594" height="36.262" viewBox="0 0 46.594 36.262">
                    <path id="Icon_ion-arrow-left-c" data-name="Icon ion-arrow-left-c" d="M20.093,9.61,6.816,23.509a4.285,4.285,0,0,0,0,5.93L20.093,43.39a3.914,3.914,0,0,0,5.718,0,4.378,4.378,0,0,0,0-5.983l-6.367-6.671H48.168a4.24,4.24,0,0,0,0-8.472H19.444l6.38-6.671a4.378,4.378,0,0,0,0-5.983,3.929,3.929,0,0,0-5.732,0Z" transform="translate(52.219 55.631) rotate(180)" fill="#F8FDFF"/>
                </svg>
            </button> 
        </div>
    )
}